import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';



var timeout1, timeout2, timeout3, timeout4;

@autobind
class SliderDesktop extends React.Component {
  state = {
    mouseHold:false,
    mouseOver:false,
    positionLeft:276,
    initialAnimation: true,
  };

  componentDidMount(){
    var container = document.querySelector("#container");

    window.addEventListener('mousedown', this.mouseDown);
    window.addEventListener('mousemove', this.handlePosition);
    window.addEventListener('mouseup', this.mouseUp);

    container.addEventListener('touchstart', this.mouseDown);
    container.addEventListener('touchmove', this.handlePosition);
    container.addEventListener('touchend', this.mouseUp);
    if(window.innerWidth > 600){
      timeout1 = setTimeout(()=>this.setState({ positionLeft:326}), 500);
      timeout2 = setTimeout(()=>this.setState({ positionLeft:206}), 1400);
      timeout3 = setTimeout(()=>this.setState({ positionLeft:276}), 2200);
      timeout4 = setTimeout(()=>this.setState({ initialAnimation:false}), 3000);
    } else {
      this.setState({ positionLeft:170});
      timeout1 = setTimeout(()=>this.setState({ positionLeft:226}), 500);
      timeout2 = setTimeout(()=>this.setState({ positionLeft:106}), 1400);
      timeout3 = setTimeout(()=>this.setState({ positionLeft:170}), 2200);
      timeout4 = setTimeout(()=>this.setState({ initialAnimation:false}), 3000);
    }
  }
  componentWillUnmount() {
    var container = document.querySelector("#container");
    window.removeEventListener('mousedown', this.mouseDown);
    window.removeEventListener('mousemove', this.handlePosition);
    window.removeEventListener('mouseup', this.mouseUp);

    container.removeEventListener('touchstart', this.mouseDown);
    container.removeEventListener('touchmove', this.handlePosition);
    container.removeEventListener('touchend', this.mouseUp);
  }

  handlePosition(e){
    var rect;
    var x;
    if(this.state.mouseHold){
      clearTimeout(timeout1);
      clearTimeout(timeout2);
      clearTimeout(timeout3);
      clearTimeout(timeout4);
      if(window.innerWidth > 600){
        if(e.clientX && this.state.mouseOver){
          rect = e.target.getBoundingClientRect();
          x = e.clientX - rect.left; 
          if(x<572 && x>22){
            this.setState({positionLeft:x-20})
          }
        } else if(e.changedTouches) {
          e.preventDefault()
          rect = e.target.getBoundingClientRect();
          x = e.changedTouches[0].clientX - rect.left;
          if(x<572 && x>22){
            this.setState({positionLeft:x-20})
          }
        }
      } else {
        if(e.clientX && this.state.mouseOver){
          rect = e.target.getBoundingClientRect();
          x = e.clientX - rect.left; 
          if(x<360 && x>22){
            this.setState({positionLeft:x-20})
          }
        } else if(e.changedTouches) {
          e.preventDefault()
          rect = e.target.getBoundingClientRect();
          x = e.changedTouches[0].clientX - rect.left;
          if(x<360 && x>22){
            this.setState({positionLeft:x-20})
          }
        }        
      }
    }
  }
  mouseDown(){
    this.setState({mouseHold:true,initialAnimation:false})
    // document.getElementsByTagName("html")[0].style.overflowY = "hidden";
  }
  mouseUp(){
    this.setState({mouseHold:false})
    // document.getElementsByTagName("html")[0].style.overflowY = "scroll";
  }
  mouseOver(){
    this.setState({mouseOver:true})
  }
  mouseOut(){
    this.setState({mouseOver:false})
  }

  render() {
    return (
      <div className={css(styles.wrapper)}>
        <div className={css(styles.innerWrapper)} onMouseOver={this.mouseOver} onMouseOut={this.mouseOut}>
          <img alt="minimaa showcase" style={this.state.initialAnimation ? {transition:"0.8s ease-in-out"} : {transition:"0s"}} width={this.state.positionLeft} className={css(styles.backgroundImg1)} src="../assets/showcaseDesktopMinimaa.png"/>
          <img alt="instagram showcase" style={this.state.initialAnimation ? {transition:"0.8s ease-in-out"} : {transition:"0s"}} width={552 - this.state.positionLeft} className={css(styles.backgroundImg21)}  src="../assets/showcaseDesktopInstagram.png"/>
          <img alt="instagram showcase" style={this.state.initialAnimation ? {transition:"0.8s ease-in-out"} : {transition:"0s"}} width={342 - this.state.positionLeft} className={css(styles.backgroundImg22)}  src="../assets/showcaseDesktopInstagram.png"/>
          <img alt="minimaa slider" style={this.state.initialAnimation ? {transition:"0.8s ease-in-out",left:"calc("+this.state.positionLeft+"px - 20px)"} : {transition:"0s",left:"calc("+this.state.positionLeft+"px - 20px)"}} className={css(styles.slider)} src="../assets/slider.png"/>
          <img style={this.state.initialAnimation ? {transition:"0.8s ease-in-out",left:"calc("+this.state.positionLeft+"px - 20px)"} : {transition:"0s",left:"calc("+this.state.positionLeft+"px - 20px)"}} className={css(styles.slider2)} alt="minimaa slider" src="../assets/slider2.png"/>
          <div id="container" className={css(styles.layer)} />
        </div>
        <div className={css(styles.text)}>Swipe left and right to change the view.</div>
      </div>
    );
  }
}
const styles = StyleSheet.create({
    wrapper:{
      paddingLeft:40,
      display:"flex",
      flexDirection:"column",
      justifyContent:"center",
      alignItems:"center",
      '@media (max-width: 1020px)': {
        paddingLeft:0,
      },
    },
    innerWrapper:{
      width:552,
      position:"relative",
      userSelect: "none",
      display:"flex",
      justifyContent:"space-between",
      borderRadius:8,
      boxShadow: "0px 2px 12px rgba(21, 23, 54, 0.15)",
      '@media (max-width: 600px)': {
         width:340,
         justifyContent:"center",
         alignItems:"center",
      },
    },
    backgroundImg1:{
      border:0,
      userSelect: "none",
      height:364,
      objectFit:"cover",
      objectPosition: "0% 0%",
      '@media (max-width: 600px)': {
        height:226,
      },
    },
    backgroundImg21:{
      border:0,
      height:364,
      userSelect: "none",
      objectFit:"cover",
      objectPosition: "100% 0%",
      '@media (max-width: 600px)': {
        display:"none",
      },
    },
    backgroundImg22:{
      border:0,
      height:226,
      userSelect: "none",
      objectFit:"cover",
      objectPosition: "100% 0%",
      '@media (min-width: 600px)': {
        display:"none",
      },
    },
    layer:{
      position:"absolute",
      background:"transparent",
      zIndex:1,
      userSelect: "none",
      touchAction: "none",
      top:0,
      left:-20,
      bottom:0,
      right:-20,
      cursor:"pointer",
    },
    slider:{
      position:"absolute",
      top:-10,
      userSelect: "none",
      height:"calc(100% + 20px)",
      '@media (max-width: 600px)': {
        display:"none",
      },
    },
    slider2:{
      position:"absolute",
      top:-10,
      touchAction: "none",
      userSelect: "none",
      height:"calc(100% + 20px)",
      '@media (min-width: 600px)': {
        display:"none",
      },
    },

    text:{
      fontSize:12,
      userSelect: "none",
      textAlign:"center",
      marginTop:20,
      color:"#A3A3A3",
    },
});

export default SliderDesktop;